import React from 'react'
import Aside from '../../shared/Aside'
import MainHeadPhones from './main/MainHeadPhones'
import HeaderHeadPhones from './header/HeaderHeadPhones'

function Headphones() {
  return (
    <>
      <HeaderHeadPhones />
      <MainHeadPhones />
      <Aside />
     
    </>
  )
}

export default Headphones